import { FC } from "react";
import { Modal } from "react-bootstrap-v5";
import { KTSVG } from "../../../helpers/KTSVG";
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { showErrorAlert } from "../../../helpers/alert";
import CityAutocompleteField from "../../../modules/auth/components/fields/CityAutocompleteField";
import { createPayoutMethod, editPayoutMethods } from "../../../services/financialService";
import { BankAccount } from "../models";

interface Props {
    show: boolean,
    onClose: () => void,
    onSubmit: (data: any) => void,
    data?: BankAccount
    host?: number
}

export const PayoutMethodModel: FC<Props> = ({ show, data, host, onClose, onSubmit }) => {
    const types = [
        { id: 'Commercial', name: 'Commercial' },
        { id: 'Impact/Philanthropy', name: 'Impact / Philanthropy' }
    ]

    const initialForm = {
        id: data?.id || 0,
        type_id: data?.typeId || 'Commercial',
        beneficiary: data?.beneficiary || '',
        bank_name: data?.bankName || '',
        swift_code: data?.swiftCode || '',
        iban: data?.iban || '',
        street_address: data?.streetAddress || '',
        apt: data?.apt || '',
        city: data?.city || '',
        state: data?.state || '',
        zip_code: data?.zipCode || '',
        is_primary: data?.isPrimary || false,
    }

    const validateSchema = Yup.object({
        id: Yup.number().nullable(),
        type_id: Yup.string().required('This field is required'),
        beneficiary: Yup.string().required('This field is required').max(100, "Max 100 characters"),
        bank_name: Yup.string().required('This field is required').max(100, "Max 100 characters"),
        swift_code: Yup.string().required('This field is required').max(100, "Max 100 characters"),
        street_address: Yup.string().required('This field is required').max(100, "Max 100 characters"),
        apt: Yup.string().required('This field is required').max(100, "Max 100 characters"),
        city: Yup.string().required('City is required'),
        state: Yup.string().required('This field is required').max(100, "Max 100 characters"),
        zip_code: Yup.string().required('This field is required').max(10, "Max 10 characters"),
        is_primary: Yup.boolean(),
    })

    const handleOnSubmit = async (values) => {
        if(values.id>0){
            let isEdited = await editPayoutMethods(values.id, values)
            if(isEdited.id){
                showErrorAlert({title: 'Edited', message: 'Payout method updated successfully.' })
                onSubmit(values)
                onClose()
            }
        }else{
            let created = await createPayoutMethod({...values, host})
            if(created.id){
                showErrorAlert({title: 'Created', message: 'Payout method saved successfully.' })
                onSubmit(values)
                onClose()
            }
        }
    }

    const stepFields = ['type_id','beneficiary','bank_name','swift_code','street_address','apt','city','state','zip_code']

    return (<Modal show={show} centered size="lg" backdrop="static" dialogClassName="team-admin-add-member-modal">
        <div className="modal-payment-method-payout">
            <div className="w-100 d-flex flex-row justify-content-between">
                <h1 className="modal-payment-method-payout__title">{data?.id > 0 ? 'Edit' : 'Add'} payout method</h1>
                <div className="rm-style-3 cursor-pointer" onClick={onClose}>
                    <KTSVG path="/media/svg/nobilis/closeX.svg" className="rm-style-4" />
                </div>
            </div>
            <Formik enableReinitialize initialValues={initialForm} validationSchema={validateSchema} onSubmit={handleOnSubmit}>
                {({ values, handleChange, isValid, validateForm, submitForm, isSubmitting }) => {
                    const haveErrors = async () => {
                        const fieldsToValidate = stepFields;
                        const errors = await validateForm();
                        const stepErrors = Object.keys(errors).filter((key) =>
                            fieldsToValidate.includes(key)
                        );
                        if(stepErrors.length>0){
                            showErrorAlert({title:'',message:`Please enter '${String(stepErrors[0]).replaceAll('_',' ')}' to save your progress.`});
                            return true;
                        }
                        return false;
                    }

                    const handleBeforeSubmit = async () => {
                        // showErrorAlert({title:'',message:'coming soon.'});
                        // return;
                        let error = await haveErrors();
                        if (!error) {
                            submitForm()
                        }
                    }

                    return (<Form className='profile-admin-form  profile-form-base' style={{ display: 'contents' }}>
                        {/* TYPE SELECT */}
                        <div className="w-100">
                            <div className='tap-add-experience-2-radio-row'>
                                {(types || []).map((type: any, index: number) => {
                                    return (<div key={`type-payout-${index}`} className={`tap-add-experience-2-radio-card ${values.type_id == type.id ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                                        <label className="tap-host-option p-6 w-100">
                                            <input type="radio" className="tap-host-radio-input"
                                                name="type_id"
                                                value={type.id}
                                                checked={values.type_id === type.id}
                                                onChange={handleChange}
                                            />
                                            <div className="tap-host-radio">
                                                <div className="tap-host-radio-outer"></div>
                                                <div className="tap-host-radio-inner"></div>
                                            </div>
                                            <div className="tap-host-option-label">{type.name}</div>
                                        </label>
                                    </div>)
                                })}
                                <ErrorMessage name='type_id' component="div" className="tap-add-experience-text text-danger" />
                            </div>

                            <div className='pf-checkbox mt-6'>
                                <input type="checkbox" className="pf-check" checked={values.is_primary} onChange={handleChange} name="is_primary"/>
                                <label htmlFor="assignment-1" className="pf-checkbox-content">
                                    <div className="assignment-title">Is primary</div>
                                </label>
                            </div>

                            <div className="tap-add-experience-2-section mt-6 gap-1">
                                <span className="team-admin-add-member__section-title">Beneficiary</span>
                                <div className='form-field team-admin-add-member__card'>
                                    <label className='field-label'>Name</label>
                                    <Field name='beneficiary' className='input' />
                                    <ErrorMessage name='beneficiary' component="div" className="tap-add-experience-text text-danger" />
                                </div>
                            </div>

                            <div className="tap-add-experience-2-section mt-6 gap-1">
                                <span className="team-admin-add-member__section-title">Bank account</span>
                                <div className='form-field team-admin-add-member__card'>
                                    <div className='w-100'>
                                        <label className='field-label'>Bank Name</label>
                                        <Field name='bank_name' className='input' />
                                        <ErrorMessage name='bank_name' component="div" className="tap-add-experience-text text-danger" />
                                    </div>
                                    <div className="w-100">
                                        <label className='field-label'>SWIFT / BIC ID / IBAN</label>
                                        <Field name='swift_code' className='input' />
                                        <ErrorMessage name='swift_code' component="div" className="tap-add-experience-text text-danger" />
                                    </div>
                                </div>
                            </div>

                            <div className="tap-add-experience-2-section mt-6 gap-1">
                                <span className="team-admin-add-member__section-title">Address</span>
                                <div className='form-field team-admin-add-member__card'>
                                    <div className="w-100">
                                        <label className='field-label'>Street Address</label>
                                        <Field name='street_address' className='input' />
                                        <ErrorMessage name='street_address' component="div" className="tap-add-experience-text text-danger" />
                                    </div>
                                    <div className="w-100">
                                        <label className='field-label mt-4'>Apt, suite, bldg</label>
                                        <Field name='apt' className='input' />
                                        <ErrorMessage name='apt' component="div" className="tap-add-experience-text text-danger" />
                                    </div>
                                    <div className="w-100">
                                        <label className='field-label mt-4'>City</label>
                                        <CityAutocompleteField name='city' />
                                        <ErrorMessage name='city' component="div" className="tap-add-experience-text text-danger" />
                                    </div>
                                    <div className="w-100 d-flex flex-row gap-6">
                                        <div className="div-flex-50">
                                            <label className='field-label mt-4'>State</label>
                                            <Field name='state' className='input' />
                                            <ErrorMessage name='state' component="div" className="tap-add-experience-text text-danger" />
                                        </div>
                                        <div className="div-flex-50">
                                            <label className='field-label mt-4'>Zip code</label>
                                            <Field name='zip_code' className='input' />
                                            <ErrorMessage name='zip_code' component="div" className="tap-add-experience-text text-danger" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* ACTIONS */}
                        <div className="modal-payment-method-payout__actions">
                            <div role='button' onClick={onClose} className={`tap-add-experience-2-btn-secondary`}>
                                Cancel
                            </div>
                            <button type="button" onClick={handleBeforeSubmit} className="tap-add-experience-2-btn-main" disabled={isSubmitting}>
                                {!isSubmitting ?  (<div className='tap-host-button-text tap-flex-center'>
                                    {values.id  > 0 ? 'Update method' : 'Add method'}
                                    &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                                </div>):(
                                    <span className='indicator-progress nb-heading-md'>
                                        Please wait...
                                        <span
                                            className='spinner-border spinner-border-sm align-middle ms-2'
                                            role='status'
                                            aria-hidden='true'
                                        />
                                    </span>
                                )}
                            </button>
                        </div>
                    </Form>)
                }}
            </Formik>
        </div>
    </Modal>);
}